/**
 * @generated SignedSource<<f6023a9b89732484d03504a3e02c9f65>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShareWidget_GetCurrentUserQuery$variables = Record<PropertyKey, never>;
export type ShareWidget_GetCurrentUserQuery$data = {
  readonly currentUser: {
    readonly " $fragmentSpreads": FragmentRefs<"user_isGuest">;
  } | null | undefined;
};
export type ShareWidget_GetCurrentUserQuery = {
  response: ShareWidget_GetCurrentUserQuery$data;
  variables: ShareWidget_GetCurrentUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guest",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ShareWidget_GetCurrentUserQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "kind": "InlineDataFragmentSpread",
            "name": "user_isGuest",
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/)
            ],
            "args": null,
            "argumentDefinitions": []
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ShareWidget_GetCurrentUserQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5a931cd41be57758b42636a1466cf197",
    "id": null,
    "metadata": {},
    "name": "ShareWidget_GetCurrentUserQuery",
    "operationKind": "query",
    "text": "query ShareWidget_GetCurrentUserQuery {\n  currentUser {\n    ...user_isGuest\n    id\n  }\n}\n\nfragment user_isGuest on User {\n  guest\n  status\n}\n"
  }
};
})();

(node as any).hash = "51206cf614313feab26ca8bd3baaa8fe";

export default node;
